export default __webpack_public_path__ + "static/PlainTee-8920ddda6e85857361ec2176f6aa553a.svg";